module.exports = __webpack_public_path__ + "img/1208.2aae5dbf.jpg";